import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPin = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPin",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M17.92 4.46A8.3 8.3 0 0 0 12 2a8.4 8.4 0 0 0-8.36 8.37c.12 3.18 3.18 7.22 5.56 10.32a3.65 3.65 0 0 0 5.7-.09c1.76-2.2 5.57-7.47 5.46-10.23 0-2.23-.87-4.34-2.44-5.91m-4.25 15.17a2.12 2.12 0 0 1-3.32 0c-3.22-4.1-5.15-7.53-5.15-9.26a6.8 6.8 0 0 1 6.8-6.8 6.8 6.8 0 0 1 6.8 6.8c0 1.75-1.87 5.12-5.13 9.26m-1.63-5.95a3.3 3.3 0 0 1-3.32-3.32c.19-4.4 6.46-4.4 6.64 0a3.3 3.3 0 0 1-3.32 3.32m0-5.08c-.97 0-1.75.8-1.75 1.76.1 2.33 3.41 2.33 3.51 0 0-.97-.79-1.76-1.76-1.76"
  })
}));